import { useContext } from 'react';
import { RouteStateContext } from '../context/RouteStateProvider';

export default function useRouteState() {
  const [routeState, setRouteState] = useContext(RouteStateContext);
  return { routeState, setRouteState };
}
